module.exports = __webpack_public_path__ + "img/delete_success.a6b724d3.svg";